import { render, staticRenderFns } from "./TariffsModal.vue?vue&type=template&id=4fe60ad4&"
import script from "./TariffsModal.vue?vue&type=script&lang=ts&"
export * from "./TariffsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TariffsModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports